import { Fragment, useState } from 'react';
import { noData } from '../../../components/ExportImgFigma';
import '../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, Pagination } from 'antd';

import { MoreOutlined, SettingOutlined } from '@ant-design/icons';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { ListField } from '../../../api/Customer_V2/customerApi_V2';
import useToast from '../../../hook/useToast';
import { ColumnKey } from '../../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../../CustomersV2/indexV2';
import TabsFeilds from '../Modal/TabsFeilds';
import { NodataTable } from '../../../components/NoDataTable';
import MegaTable from '../../../components/MagaTableV2';
dayjs.locale('vi');


interface Props {
  dataRow: any[]
  columnDefs: any[]
}

const TabTableDetail = ({ stData = {} as any }) => {

  const pushToast = useToast();

  const [isSettingShow, setSettingShow] = useState(false)

  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

  const [demoList, setDemoList] = useState<any[]>([])
  const [rowHeight, setRowHeight] = useState(40)

  const onSaveDataFields = () => { }
  const onCloseDataFields = () => {
    setSettingShow(false)
  }

  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.customer_care_detail?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }

  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheSalesAndServiceDetail',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { headerName: 'Số khung (VIN)', field: 'own_chassis_no' },
      // { headerName: 'Biển số xe', field: 'own_number_plate' },
      // { headerName: 'Số máy', field: 'own_engine_no' },
      // { headerName: 'Màu xe', field: 'own_color_name' },
      // { headerName: 'Ngày mua xe', field: 'own_purchase_date' },
      // { headerName: 'Loại động cơ', field: 'own_engine_type' },
      // { headerName: 'Ngày liên hệ lần 1', field: 'contact_date_1' },
      // { headerName: 'Nội dung liên hệ lần 1', field: 'contact_details_1' },
      // { headerName: 'Ngày liên hệ lần 2', field: 'contact_date_2' },
      // { headerName: 'Nội dung liên hệ lần 2', field: 'contact_details_2' },
      // { headerName: 'Ngày liên hệ lần 3', field: 'contact_date_3' },
      // { headerName: 'Nội dung liên hệ lần 3', field: 'contact_details_3' },
      // { headerName: 'Không liên hệ được', field: 'contact_unreachable' },
      // { headerName: 'Nội dung ', field: 'contact_notes' },
    ],
    listData: [],
    selectedRowKeys: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
  });

  return (
    <Fragment>
      {
        isSettingShow ?
          <TabsFeilds
            isSettingShow={isSettingShow}
            dataFilterActive={dataFilterActive}
            dataFilterNoActive={dataFilterNoActive}

            onSaveDataFields={onSaveDataFields}
            onClose={onCloseDataFields}
          /> :
          null
      }
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className="w-full flex items-center justify-end">

          <div className="custom-page-css absolute -top-60-px z-10 flex items-center justify-end gap-3 ">
            <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer"
              onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}
            >
              <SettingOutlined />
            </div>

          </div>
        </div>
        <div className={` w-full`}>
          <MegaTable
            stData={{ ...megaTableData, listData: stData.chamsocbanhangdichvu_show ? [stData.chamsocbanhangdichvu_show] : [] }}
            stChange={(data = {}, type = '') => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
          />
          {/* <div className="ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
                        <AgGridReact<any>
                            rowSelection={undefined}
                            rowData={dataRow}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                resizable: true,
                                sortable: true,
                            }}
                            domLayout="autoHeight"
                            className="my-auto-height-grid"
                            rowHeight={55}
                            getRowStyle={(params: any) => ({
                                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                            })}
                            overlayNoRowsTemplate={NodataTable}
                        />
                    </div> */}
        </div>
      </div>
    </Fragment>
  )

}

export default TabTableDetail
